<template>
  <div class="panel cc-panel">
    <p class="panel-heading">
      {{ $t("i18n.chartTitles.ccAverageCOP") }}
    </p>
    <div class="panel-block">
      <div :id="this.idChartDiv" class="cc-chart"></div>
    </div>
  </div>
</template>
<script>
import * as am5 from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import * as am5exporting from '@amcharts/amcharts5/plugins/exporting'
import ccColors from '@/components/ccColors'

export default {
  name: 'ccAverageCOP',
  props: {
    idChartDiv: {
      type: String,
      required: true
    },
    totals: {
      type: Object,
      required: true
    },
    unitApplicationTotals: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.buildChart()
  },
  methods: {
    buildChart: function () {
      am5.addLicense(this.$store.state.am5)
      const root = am5.Root.new(this.idChartDiv)

      // Create chart
      // https://www.amcharts.com/docs/v5/charts/xy-chart/
      const chart = root.container.children.push(am5xy.XYChart.new(root, {
        layout: root.verticalLayout,
        paddingTop: 35
      }))

      const data = []
      this.unitApplicationTotals.forEach((total, index) => {
        let category = this.$t('i18n.unitApplications.' + total.application)
        if (total.application === 'UKN') {
          category += ' ' + this.$t('i18n.systemList.header')
        }

        data.push({
          category: category + ' ' + this.$t('i18n.global.totalCoolingCop'),
          value: total.compressorCoolingCop,
          columnSettings: {
            fill: ccColors.cold[index]
          }
        })
        data.push({
          category: category + ' ' + this.$t('i18n.global.totalHeatingCop'),
          value: total.compressorHeatingCop,
          columnSettings: {
            fill: ccColors.warm[index]
          }
        })
      })

      const xRenderer = am5xy.AxisRendererX.new(root, {
        minGridDistance: 30
      })

      // Create axes
      // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
      const xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
        categoryField: 'category',
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {})
      }))

      xAxis.data.setAll(data)

      xAxis.get('renderer').labels.template.setAll({
        rotation: -60,
        centerY: am5.p50,
        centerX: am5.p100,
        textAlign: 'center',
        oversizedBehavior: 'wrap',
        maxWidth: 100
      })

      const yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0
      }))

      // Add series
      const series = chart.series.push(am5xy.ColumnSeries.new(root, {
        name: 'CopAverages',
        xAxis: xAxis,
        yAxis: yAxis,
        baseAxis: xAxis,
        valueYField: 'value',
        categoryXField: 'category',
        tooltip: am5.Tooltip.new(root, {
          labelText: '{valueY}'
        })
      }))

      series.columns.template.setAll({
        strokeWidth: 0,
        stroke: 0,
        templateField: 'columnSettings'
      })

      series.data.setAll(data)

      // Add export menu
      am5exporting.Exporting.new(root, {
        menu: am5exporting.ExportingMenu.new(root, {})
      })

      chart.children.unshift(am5.Label.new(root, {
        text: 'COP',
        fontWeight: '500',
        textAlign: 'center',
        y: am5.percent(-13),
        height: 0,
        paddingTop: 0
      }))

      // Make stuff animate on load
      chart.appear(1000, 100)
    }
  }
}
</script>
